import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isNull, map } from 'lodash-es'
import { FormattedMessage } from 'react-intl'

import ButtonComponent from '../ButtonComponent/ButtonComponent'
import RadioButtonComponent from '../RadioButtonComponent/RadioButtonComponent'
import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'

import './PollVoteComponent.scss'

const getRadioButtonStyles = (radioButtonStyles) => {
  return { text: { fontSize: 12 }, ...radioButtonStyles }
}

const PollVoteComponent = ({
  poll,
  question,
  radioButtonStyles,
  answerPoll,
}) => {
  const webinarColors = useWebinarColors()

  const [selected, setSelected] = useState(null)
  const isButtonDisabled = isNull(selected)

  return (
    <div className="poll-vote-component">
      {question}
      {map(poll.options, (option) => {
        const id = option.poll_option_id

        return (
          <RadioButtonComponent
            key={id}
            name="answer"
            id={id}
            checked={id === selected}
            label={option.option}
            onChange={() => setSelected(id)}
            styles={getRadioButtonStyles(radioButtonStyles)}
          />
        )
      })}
      <div className="vote-button-wrapper">
        <ButtonComponent
          style={{
            backgroundColor: webinarColors.accent.color,
            color: webinarColors.accent.contrast.color,
            opacity: isButtonDisabled ? 0.6 : 1,
          }}
          color="transparent"
          onClick={() =>
            answerPoll(poll, selected, window.localStorage?.getItem('uuid'))
          }
          disabled={isButtonDisabled}
          className="vote-button"
          round
        >
          <FormattedMessage defaultMessage="Vote" />
        </ButtonComponent>
      </div>
    </div>
  )
}

PollVoteComponent.propTypes = {
  poll: PropTypes.object,
  answerPoll: PropTypes.func,
  radioButtonStyles: PropTypes.shape({
    passiveColor: PropTypes.string,
    activeColor: PropTypes.string,
  }),
  question: PropTypes.node,
}

PollVoteComponent.defaultProps = {
  radioButtonStyles: {},
}

export default PollVoteComponent
